import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { filterValidNotifications, Notification } from '../../utils/notificationUtils';

interface NotificationState {
    notifications: Notification[];
    isLoading: Boolean;
    error: string | null;
}

const initialState: NotificationState = {
    notifications: [],
    isLoading: false,
    error: null,
};

const notificationListSlice = createSlice({
    name: 'notificationLists',
    initialState,
    reducers: {
        setNotificationList: (state : NotificationState, action: PayloadAction<any[]>) => {
            // Filter out empty or invalid notifications before concatenating
            const validNewNotifications = filterValidNotifications(action.payload);
            
            if (validNewNotifications.length > 0) {
                state.notifications = state.notifications.concat(validNewNotifications);
            }
            state.isLoading = false;
            state.error = null;
        },
        isloading: (state: NotificationState, action: PayloadAction<Boolean>) => {
            state.isLoading = action.payload;
            state.error = null; 
        },
        seterror: (state : NotificationState, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetNotificationList: () => {
            return initialState;
        },
    },
});

export const { setNotificationList, isloading, seterror, resetNotificationList } = notificationListSlice.actions;

export default notificationListSlice.reducer;
